/* eslint-disable no-unused-vars */
import { memo, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { calendarSelector } from '@/helpers/props';
import { setBasicFilters } from '@/redux/store/actions/search';
import CalendarDesktop from '@/components/reusable/searchDatePicker/calendarDesktop/CalendarDesktop';
import CalendarMobile from '@/components/reusable/searchDatePicker/calendarMobile/CalendarMobile';
import useSearchParams from '@/components/search/hooks/useSearchParams';
import useDevice from '@/hooks/useDevice';
import FilterChips from '../reusabe/filterChips/FilterChips';
import useDrawer from '@/hooks/useDrawer';
import Box from '@/components/UI/box/Box';
import DatePickerDescription from '@/components/houses/_reusable/datePickerDescription/DatePickerDescription';
import styles from './DatePicker.module.scss';
import Alert from '@/components/UI/alert/Alert';
import heap from '@/helpers/heap';
import Menu from '@/components/UI/menu/Menu';
import { useRouter } from 'next/router';
const DatePicker = () => {
  const {
    setQuery,
    queries,
    params
  } = useSearchParams();
  const {
    drawerOpen,
    drawerClose,
    isDrawerOpen
  } = useDrawer();
  const router = useRouter();
  const isMidTerm = router?.query?.mid_term === '1';
  const open = isDrawerOpen('CALENDAR');
  const calendar = useSelector(state => calendarSelector(state, 'searchCalendar'));
  const {
    checkin,
    checkout,
    guests
  } = useSelector(state => state.basicFilters);
  const hasCheckinCheckout = !!checkin && !!checkout;
  const {
    isMobile
  } = useDevice();
  const dispatch = useDispatch();
  const calendarRef = useRef<any>(null);
  const closeRef = useRef<any>(null);
  useEffect(() => {
    if (params.city === 'تهران' && checkin && checkout) {
      const daysDifference = getDifferenceBetweenDays(checkin, checkout);
      if (daysDifference < 20) {
        heap.track('losing midterm discount', {});
      }
    }
  }, [checkin, checkout, params.city]);
  const handleClick = () => {
    if (open) {
      drawerClose();
    } else {
      drawerOpen('CALENDAR');
    }
  };
  const getDifferenceBetweenDays = (checkin, checkout) => {
    const differenceInMilliseconds = Math.abs(checkout - checkin);
    const differenceInDays = Math.ceil(differenceInMilliseconds / (60 * 60 * 24));
    return differenceInDays;
  };
  const submitData = ({
    checkin,
    checkout
  }) => {
    setQuery({
      checkin,
      checkout,
      mid_term: params?.city === 'تهران' && getDifferenceBetweenDays(checkin, checkout) >= 20 ? 1 : undefined
    });
  };
  const handleDatePickerChange = (dates: any) => {
    dispatch(setBasicFilters({
      checkin: dates.checkin,
      checkout: dates.checkout,
      guests
    }));
    if (dates.submited || !isMobile && dates.checkout) {
      submitData(dates);
    }
  };
  const cleanDatePicker = () => {
    calendarRef.current?.cleanValue();
    dispatch(setBasicFilters({
      checkin: null,
      checkout: null,
      guests
    }));
    setQuery({
      checkin: undefined,
      checkout: undefined
    });
  };
  const resetFilter = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    cleanDatePicker();
  };
  const formatTime = time => {
    const timeDate = new Date(time * 1000);
    const [month, day] = timeDate.toLocaleDateString('fa-IR', {
      day: 'numeric',
      month: 'long'
    }).split(' ');
    return ` ${month} ${day}`;
  };
  return <Box className={styles['filter-item-wrapper']} data-sentry-element="Box" data-sentry-component="DatePicker" data-sentry-source-file="DatePicker.tsx">
      <FilterChips type={isMidTerm ? 'secondary' : 'primary'} checked={!!queries.checkin} handleClick={handleClick} handleClean={resetFilter} label={queries.checkin && queries.checkout ? `
            ${formatTime(+queries.checkin)}
            تا
            ${formatTime(+queries.checkout)}
          ` : 'انتخاب تاریخ '} startIcon="calendar" endIcon={true} name="date_filter" id="calendar-chips" data-sentry-element="FilterChips" data-sentry-source-file="DatePicker.tsx" />
      {!isMobile ? <Menu ref={closeRef} id="datepicker" menuButtonId="calendar-chips" open={open} handleClose={drawerClose} className={styles['filter-item-container']}>
          <CalendarDesktop calendar={calendar} calendarRef={calendarRef} open={open} checkin={checkin} checkout={checkout} handleChange={handleDatePickerChange} withTooltip={false} isMidterm={isMidTerm} />
          {params.city === 'تهران' && queries.mid_term && <Box className={styles['datepicker-description']}>
              <DatePickerDescription />
            </Box>}
        </Menu> : <CalendarMobile onClose={drawerClose} open={isDrawerOpen('CALENDAR')} handleDatePickerChange={handleDatePickerChange} resetFilter={cleanDatePicker} calendarRef={calendarRef} withTooltip={false} isMidterm={isMidTerm} banner={params.city === 'تهران' && queries.mid_term && (!hasCheckinCheckout ? <Box className={styles['mid-term-alert']}>
                <DatePickerDescription />
              </Box> : getDifferenceBetweenDays(checkin, checkout) < 20 && <Box className={styles['mid-term-alert']}>
                  <Alert title="بازه زمانی انتخابی شما شامل تخفیف بلند رزرو مدت نمی‌شود." type="error" icon="info-circle" />
                </Box>)} />}
    </Box>;
};
export default memo(DatePicker);